// extracted by mini-css-extract-plugin
export default {"indicator":"reDeliveryIndicator_indicator__M+Gov","number":"reDeliveryIndicator_number__ijDfU"};